import { useEffect } from 'react';
// emotion
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
// @mui
import { useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function ThemeRtlLayout({ children }: Props) {
  const theme = useTheme();

  useEffect(() => {
    document.dir = theme.direction;
  }, [theme.direction]);

  const cache = createCache({
    key: 'css',
  });

  return <CacheProvider value={cache}>{children}</CacheProvider>;
}
